import { Dispatch, SetStateAction, createContext } from 'react'

interface IPaginationButtonsContext {
  count: number
  page: number
  setPage: Dispatch<SetStateAction<number>>
  rowsPerPage: number
  setRowsPerPage: Dispatch<SetStateAction<number>>
  isShown: boolean
  withAll?: boolean
}

export const PaginationContext = createContext<IPaginationButtonsContext | null>(null)
